'use strict';
import $ from 'jquery';
import Swiper, { Navigation } from 'swiper';
Swiper.use([Navigation]);

$(document).ready(function () {
    $('.product-main__small-image').click(function () {
        const self = $(this);
        if (self.hasClass('product-main__small-image--active')) return;

        const id = self.attr('data-id');
        $('.product-main__small-image').removeClass('product-main__small-image--active');
        self.addClass('product-main__small-image--active');

        $('.product-main__big-image').removeClass('product-main__big-image--active');
        $('.product-main__big-image[data-id="' + id + '"]').addClass('product-main__big-image--active');
    });

    $('.product-description__tab').click(function () {
        const self = $(this);
        if (self.hasClass('product-description__tab--active')) return;

        const id = self.attr('data-id');
        $('.product-description__tab').removeClass('product-description__tab--active');
        self.addClass('product-description__tab--active');

        const all = $('.product-description__tabs-details');
        all.removeClass('product-description__tabs-details--active');
        all.hide();

        const current = $('.product-description__tabs-details[data-id="' + id + '"]');
        current.addClass('product-description__tabs-details--active');
        current.fadeIn();
    });

    $('.product-slider__slider-holder').each(function () {
        const slider = new Swiper(this, { // eslint-disable-line no-unused-vars
            loop: false,
            slidesPerView: 3,
            spaceBetween: 15,
            centeredSlides: true,
            navigation: {
                nextEl: '.product-slider__button-next',
                prevEl: '.product-slider__button-prev',
            },
            breakpoints: {
                767: {
                    loop: true,
                    slidesPerView: 3,
                    spaceBetween: 22,
                    centeredSlides: false
                }
            }
        });
    });
});
